const atualizarLocais = (state, locais) => {
    state.locais = locais;
}

const atualizarLocal = (state, local) => {
    state.local = local;
}

const addLocal = (state, local) => {
    if (!local || local.id == null) return;

    state.locais.push(JSON.parse(JSON.stringify(local)));
}

const updateLocal = (state, local) => {
    if (!local || local.id == null) return;

    const index = state.locais.findIndex(item => item.id === local.id);
    if (index >= 0) {
        state.locais.splice(index, 1, JSON.parse(JSON.stringify(local)));
    }
}

export default {
    atualizarLocais,
    atualizarLocal,
    addLocal,
    updateLocal
}
